import React, { useEffect, useState } from "react";
import SiteAttachmentTable from "../views/Sites/SiteAttachmentTable";
import { useDispatch, useSelector } from "../../store";
import {
  deleteAttachment,
  getAttachmentId,
  getSiteAttachments,
  postAttachment,
  resetAttachment,
} from "../../slices/attachment";
import { useParams } from "react-router-dom";
import { Box, CircularProgress, useTheme } from "@mui/material";
import { Base } from "../base";
import Attachment from "../../types/attachment";
import { deleteJob, getSiteJobs, resetJob } from "../../slices/job";
import SitesDialog from "../../types/sitesDialog";
import TabNavButton from "../../types/tabNavButton";
import { AttachFile } from "@mui/icons-material";
import SiteInfo from "../views/Sites/SiteInfo";
import { getSiteId } from "../../slices/site";
import getJobTypeColor from "../../helpers/getJobTypeColor";
import ConfirmDeleteForm from "../forms/ConfirmDeleteForm";

interface Props {}

const SiteViewPage: React.FC<Props> = (props) => {
  const theme = useTheme();
  const dispatch = useDispatch();
  const { id } = useParams();
  const { site, status } = useSelector((store) => store.site);
  const { status: attachmentStatus } = useSelector(
    (store) => store.attachments,
  );
  const [deleteModal, setDeleteModal] = useState<SitesDialog>({
    visible: false,
  });
  const [activeTab, setActiveTab] = useState(0);
  const [highlightId, setHighlightId] = useState(0);

  useEffect(() => {
    if (activeTab === 0) {
      dispatch(getSiteAttachments(+id!));
    } else {
      dispatch(getSiteJobs({ siteId: +id!, jobTypeId: activeTab }));
    }
    if (site.id !== +id!) {
      dispatch(getSiteId(+id!));
    }
  }, [dispatch, activeTab]);

  const handleUploadAttachment = (files: File[]) => {
    files.forEach((file) => {
      dispatch(
        postAttachment({
          ...file,
          name: file.name,
          upload: file,
          siteId: +id!,
        }),
      ).then((result) => {
        if (result.meta.requestStatus === "fulfilled") {
          dispatch(getSiteAttachments(+id!));
        }
      });
    });
  };

  const closeDelete = () => {
    setDeleteModal({ visible: false, dialog: undefined });
    handleReset();
    setHighlightId(0);
  };

  const handleDownload = (id: number) => {
    dispatch(getAttachmentId(id)).then((result) => {
      let file = result.payload as Attachment;
      let a = document.createElement("a");
      a.href = file?.url!;
      a.download = file.name!;
      a.click();
      a.remove();
    });
  };

  const handleViewJob = (id?: number) => {
    handleReset();
    // navigate(`/job/view${+(id ?? 0) > 0 ? "/" + id : ""}`);
    window.open(
      `/job/view${+(id ?? 0) > 0 ? "/" + id : ""}`,
      "_blank",
      "noopener,noreferrer",
    );
  };

  const handleDelete = async () => {
    switch (deleteModal.dialog) {
      case "jobs":
        dispatch(deleteJob(deleteModal?.id!)).then(() => {
          dispatch(getSiteJobs({ siteId: +id!, jobTypeId: activeTab }));
          dispatch(resetJob());
        });
        break;
      case "attachments":
        dispatch(deleteAttachment(deleteModal?.id!)).then(() => {
          dispatch(getSiteAttachments(+id!));
          dispatch(resetAttachment());
        });
        break;
      default:
        break;
    }
    setDeleteModal({
      visible: false,
      dialog: undefined,
      id: undefined,
      name: undefined,
    });
    setHighlightId(0);
  };

  const handleReset = () => {
    dispatch(resetAttachment());
    dispatch(resetJob());
  };

  const deleteJobMessage = `Are you sure you would like to delete this job? This cannot be undone`;
  const deleteAttachmentMessage = `Are you sure you would like to delete ${deleteModal.name}? This cannot be undone`;

  const tabs: TabNavButton[] = [
    {
      id: 0,
      label: "Attachments",
      element: (
        <SiteAttachmentTable
          uploadFiles={handleUploadAttachment}
          setDeleteModal={setDeleteModal}
          handleDownload={handleDownload}
          setHighlightId={setHighlightId}
          highlightId={highlightId}
        />
      ),
      icon: <AttachFile />,
      color: theme.palette.primary.light,
    },
    // {
    //   id: 1,
    //   label: "Service Ticket",
    //   element: (
    //     <SiteJobTable
    //       setDeleteModal={setDeleteModal}
    //       apiGetJob={(id: number) => {
    //         dispatch(getJobById(id));
    //       }}
    //       setHighlightId={setHighlightId}
    //       highlightId={highlightId}
    //       backgroundColor={getJobTypeColor(1)}
    //       handleViewJob={(id: number) => handleViewJob(id)}
    //     />
    //   ),
    //   icon: <FontAwesomeIcon icon={getJobTypeIcon("faTicket")} size="lg" />,
    //   color: theme.palette.error.main,
    // },
    // {
    //   id: 2,
    //   label: "Project",
    //   element: (
    //     <SiteJobTable
    //       setDeleteModal={setDeleteModal}
    //       apiGetJob={(id: number) => {
    //         dispatch(getJobById(id));
    //       }}
    //       setHighlightId={setHighlightId}
    //       highlightId={highlightId}
    //       backgroundColor={getJobTypeColor(2)}
    //       handleViewJob={(id: number) => handleViewJob(id)}
    //     />
    //   ),
    //   icon: <FontAwesomeIcon icon={getJobTypeIcon("faBuilding")} size="lg" />,
    //   color: theme.palette.primary.main,
    // },
    // {
    //   id: 3,
    //   label: "Small Job",
    //   element: (
    //     <SiteJobTable
    //       setDeleteModal={setDeleteModal}
    //       apiGetJob={(id: number) => {
    //         dispatch(getJobById(id));
    //       }}
    //       setHighlightId={setHighlightId}
    //       highlightId={highlightId}
    //       backgroundColor={getJobTypeColor(3)}
    //       handleViewJob={(id: number) => handleViewJob(id)}
    //     />
    //   ),
    //   icon: <FontAwesomeIcon icon={getJobTypeIcon("faBriefcase")} size="lg" />,
    //   color: theme.palette.info.main,
    // },
    // {
    //   id: 4,
    //   label: "PM",
    //   element: (
    //     <SiteJobTable
    //       setDeleteModal={setDeleteModal}
    //       apiGetJob={(id: number) => {
    //         dispatch(getJobById(id));
    //       }}
    //       setHighlightId={setHighlightId}
    //       highlightId={highlightId}
    //       backgroundColor={getJobTypeColor(4)}
    //       handleViewJob={(id: number) => handleViewJob(id)}
    //     />
    //   ),
    //   icon: <FontAwesomeIcon icon={getJobTypeIcon("faWrench")} size="lg" />,
    //   color: theme.palette.tertiary.main,
    // },
    // {
    //   id: 5,
    //   label: "Sandbox/Testing",
    //   element: (
    //     <SiteJobTable
    //       setDeleteModal={setDeleteModal}
    //       apiGetJob={(id: number) => {
    //         dispatch(getJobById(id));
    //       }}
    //       setHighlightId={setHighlightId}
    //       highlightId={highlightId}
    //       backgroundColor={getJobTypeColor(5)}
    //       handleViewJob={(id: number) => handleViewJob(id)}
    //     />
    //   ),
    //   icon: <FontAwesomeIcon icon={getJobTypeIcon("faBoxOpen")} size="lg" />,
    //   color: theme.palette.warning.main,
    // },
  ];

  return (
    <Box
      sx={{
        margin: { sm: 5, xs: 0 },
        display: "flex",
        flexDirection: "column",
        gap: { xs: 3, sm: 0 },
      }}
    >
      {status === "loading" ? (
        <>
          <Base.Text text="Loading, please wait..." variant="h3" />
          <CircularProgress />
        </>
      ) : (
        <>
          <Base.TitleBar title={site?.name!} />
          <SiteInfo apiGetSite={(id) => dispatch(getSiteId(id))} />
          <Base.TabNav
            activeTab={activeTab}
            setActiveTab={setActiveTab}
            tabs={tabs}
            activeBackgroundColor={
              activeTab > 0
                ? getJobTypeColor(activeTab)
                : theme.palette.primary.light
            }
          />
        </>
      )}
      <Base.Modal
        open={deleteModal.visible && deleteModal.dialog === "jobs"}
        onClose={closeDelete}
      >
        <Box
          sx={{
            backgroundColor: theme.palette.background.paper,
            width: 500,
            borderRadius: "10px",
            padding: "15px",
          }}
        >
          <ConfirmDeleteForm
            handleCancel={closeDelete}
            handleDelete={handleDelete}
          />
        </Box>
      </Base.Modal>
      <Base.Dialog
        open={deleteModal.visible && deleteModal.dialog === "attachments"}
        title={deleteAttachmentMessage}
        handleCancel={closeDelete}
        confirmText="Delete"
        confirmButtonType="delete"
        handleConfirm={handleDelete}
        loading={attachmentStatus === "loading"}
      />
    </Box>
  );
};

export default SiteViewPage;
